import { resolveValue, useToaster } from 'react-hot-toast/headless';

import { Toast } from '@/components/ui/daisy/toast';

const TOAST_DURATION = 2500;

const ToastContainer = () => {
  const { toasts, handlers } = useToaster({ duration: TOAST_DURATION });
  const { startPause, endPause } = handlers;

  return (
    <Toast
      vertical="top"
      horizontal="center"
      className="z-9999"
      onMouseEnter={startPause}
      onMouseLeave={endPause}
    >
      {toasts
        .filter(toast => toast.visible)
        .map(toast => (
          <div key={toast.id} {...toast.ariaProps} className="translate-y-3">
            {resolveValue(toast.message, toast)}
          </div>
        ))}
    </Toast>
  );
};

export default ToastContainer;
